import { gql } from 'apollo-angular';

export const SETTINGS_USER_VALIDATION_QUERY = gql`
  query GetUserValidation {
    validateUser {
      data {
        userIsActive
        termsAcceptanceRedirectUrl
        policySubCode
        isDnvUser
        userEmail
        veracityId
        portalLanguage
        lastLoginTime
        isAdmin
        accessType
        activatedInVeracity
      }
      errorCode
      isSuccess
      message
    }
  }
`;
